import { GutterSystemViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/GutterSystemViewModel";
// Libraries
import { action, computed } from "mobx";

// Core
import { ViewModelBase } from "Core/ViewModels";
import { FieldType } from "Core/Utils/Utils";

// Custom
import { QuoteModel } from "Custom/Models/Domain/ProductSelector/SubModels/Quote";
import { QuoteItemViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/QuoteItemViewModel";

export class QuoteViewModel extends ViewModelBase<QuoteModel> {
    private gutterSystemViewModel: GutterSystemViewModel;

    constructor(model: QuoteModel, gutterSystemViewModel: GutterSystemViewModel) {
        super(model);
        this.gutterSystemViewModel = gutterSystemViewModel;
    }

    // #region Gutter Quote

    @computed
    public get gutterProductViewModels(): QuoteItemViewModel[] {
        const productViewModels = [];

        for (const product of this.model.gutterProducts) {
            productViewModels.push(new QuoteItemViewModel(product));
        }

        return productViewModels;
    }

    @computed
    public get canDisplayGutterProductsDelcoteGS(): boolean {
        return this.model.gutterProducts.length > 0 && this.model.gutterProducts.findIndex((gp) => gp.productName.includes("Delcote")) !== -1;
    }

    @computed
    public get canDisplayGutterProductsPlygene(): boolean {
        return this.model.gutterProducts.length > 0 && this.model.gutterProducts.findIndex((gp) => gp.productName.includes("Plygene")) !== -1;
    }

    @computed
    public get delcoteGSChosen(): boolean {
        return this.gutterSystemViewModel.productSelection.value === "id_delcotegs";
    }

    @computed
    public get delcoteGSReverted(): boolean {
        return this.gutterSystemViewModel.productSelection.value === "id_plygene" && this.gutterSystemViewModel.originalSource === "id_delcotegs";
    }

    @computed
    public get totalGutterProductsPrice(): string {
        let retVal: string = "POA";
        let totalPrice: number = 0.0;
        let priceOnApplication: boolean = false;

        for (const product of this.model.gutterProducts) {
            if (product.unitPrice >= 0) {
                totalPrice += product.units * product.unitPrice;
            } else {
                priceOnApplication = true;
            }
        }

        if (priceOnApplication === false) {
            retVal = `£${totalPrice.toFixed(2)}`;
        }

        return retVal;
    }

    // #endregion Gutter Quote

    // #region Roof Quote

    @computed
    public get roofProductViewModels(): QuoteItemViewModel[] {
        const productViewModels = [];

        for (const product of this.model.roofProducts) {
            productViewModels.push(new QuoteItemViewModel(product));
        }

        return productViewModels;
    }

    @computed
    public get canDisplayRoofProducts(): boolean {
        return this.model.roofProducts.length > 0;
    }

    @computed
    public get totalRoofProductsPrice(): string {
        let retVal: string = "POA";
        let totalPrice: number = 0.0;
        let priceOnApplication: boolean = false;

        for (const product of this.model.roofProducts) {
            if (product.unitPrice >= 0) {
                totalPrice += product.units * product.unitPrice;
            } else {
                priceOnApplication = true;
            }
        }

        if (priceOnApplication === false) {
            retVal = `£${totalPrice.toFixed(2)}`;
        }

        return retVal;
    }

    // #endregion Roof Quote

    // #region Total Price

    @computed
    public get totalProductsPrice(): string {
        let retVal: string = "POA";
        let totalPrice: number = 0.0;
        let priceOnApplication: boolean = false;

        for (const product of this.model.gutterProducts) {
            if (product.unitPrice >= 0) {
                totalPrice += product.units * product.unitPrice;
            } else {
                priceOnApplication = true;
            }
        }

        for (const product of this.model.roofProducts) {
            if (product.unitPrice >= 0) {
                totalPrice += product.units * product.unitPrice;
            } else {
                priceOnApplication = true;
            }
        }

        if (priceOnApplication === false) {
            retVal = `£${totalPrice.toFixed(2)}`;
        }

        return retVal;
    }

    // #endregion Total Price

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<QuoteModel>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
